export const SITE_URL = "https://equestrianpartners.net";
export const LANGS = ["en", "es", "fr", "de", "it", "pt"];

// Single source of truth for the multilingual URL architecture (en = root, others prefixed).
export const ROUTES = {
  home: { en: "/", es: "/es", fr: "/fr", de: "/de", it: "/it", pt: "/pt" },
  services: { en: "/services", es: "/es/servicios", fr: "/fr/services", de: "/de/leistungen", it: "/it/servizi", pt: "/pt/servicos" },
  events: { en: "/events", es: "/es/eventos", fr: "/fr/evenements", de: "/de/events", it: "/it/eventi", pt: "/pt/eventos" },
  industries: { en: "/industries", es: "/es/industrias", fr: "/fr/secteurs", de: "/de/branchen", it: "/it/settori", pt: "/pt/industrias" },
  products: { en: "/products", es: "/es/productos", fr: "/fr/produits", de: "/de/produkte", it: "/it/prodotti", pt: "/pt/produtos" },
  productArena: { en: "/products/arena", es: "/es/productos/arena", fr: "/fr/produits/arena", de: "/de/produkte/arena", it: "/it/prodotti/arena", pt: "/pt/produtos/arena" },
  productCentauros: { en: "/products/centauros", es: "/es/productos/centauros", fr: "/fr/produits/centauros", de: "/de/produkte/centauros", it: "/it/prodotti/centauros", pt: "/pt/produtos/centauros" },
  productAos: { en: "/products/aos-equestrian", es: "/es/productos/aos-equestrian", fr: "/fr/produits/aos-equestrian", de: "/de/produkte/aos-equestrian", it: "/it/prodotti/aos-equestrian", pt: "/pt/produtos/aos-equestrian" },
  about: { en: "/about", es: "/es/nosotros", fr: "/fr/a-propos", de: "/de/ueber-uns", it: "/it/chi-siamo", pt: "/pt/sobre" },
  contact: { en: "/contact", es: "/es/contacto", fr: "/fr/contact", de: "/de/kontakt", it: "/it/contatti", pt: "/pt/contacto" },
  faq: { en: "/faq", es: "/es/faq", fr: "/fr/faq", de: "/de/faq", it: "/it/faq", pt: "/pt/faq" },
  book: { en: "/book", es: "/es/reservar", fr: "/fr/reserver", de: "/de/termin", it: "/it/prenota", pt: "/pt/reservar" },
  blog: { en: "/blog", es: "/es/blog", fr: "/fr/blog", de: "/de/blog", it: "/it/blog", pt: "/pt/blog" },
  privacy: { en: "/privacy", es: "/es/privacidad", fr: "/fr/confidentialite", de: "/de/datenschutz", it: "/it/privacy", pt: "/pt/privacidade" },
  cookies: { en: "/cookies", es: "/es/cookies", fr: "/fr/cookies", de: "/de/cookies", it: "/it/cookie", pt: "/pt/cookies" },
  terms: { en: "/terms", es: "/es/terminos", fr: "/fr/conditions", de: "/de/agb", it: "/it/termini", pt: "/pt/termos" },
  ventures: { en: "/ventures", es: "/es/ventures", fr: "/fr/ventures", de: "/de/ventures", it: "/it/ventures", pt: "/pt/ventures" },
  technology: { en: "/technology", es: "/es/tecnologia", fr: "/fr/technologie", de: "/de/technologie", it: "/it/tecnologia", pt: "/pt/tecnologia" },
  work: { en: "/work", es: "/es/proyectos", fr: "/fr/projets", de: "/de/projekte", it: "/it/progetti", pt: "/pt/projetos" },
  eventsCapabilities: { en: "/events/capabilities", es: "/es/eventos/capacidades", fr: "/fr/evenements/capacites", de: "/de/events/kompetenzen", it: "/it/eventi/competenze", pt: "/pt/eventos/capacidades" },
};

export function eventPath(lang, slug) {
  return `${ROUTES.events[lang] || ROUTES.events.en}/${slug}`;
}

export function langFromPath(pathname) {
  const seg = pathname.split("/")[1];
  return LANGS.includes(seg) && seg !== "en" ? seg : "en";
}

export function routePath(key, lang) {
  const r = ROUTES[key];
  return r ? r[lang] || r.en : "/";
}

// Equivalent localized URL for the language selector.
export function switchLangPath(pathname, target) {
  for (const key of Object.keys(ROUTES)) {
    const r = ROUTES[key];
    if (Object.values(r).includes(pathname)) return r[target] || r.en;
  }
  const m = pathname.match(/^(?:\/(es|fr|de|it|pt))?\/blog(\/.*)?$/);
  if (m) return routePath("blog", target);
  return routePath("home", target);
}

export function blogArticlePath(lang, slug) {
  return lang === "en" ? `/blog/${slug}` : `/${lang}/blog/${slug}`;
}
